// extracted by mini-css-extract-plugin
export default {"card-image":"Framing_card-image__LIEpL","link":"Framing_link__IEPfn"};